<template>
  <div class="flex flex-col h-full overflow-hidden">
    <div class="flex-1 flex flex-col min-h-0 overflow-y-auto">
      <!--     Provider List     -->
      <div v-if="providers.length === 0" class="flex flex-col">
        <div v-for="i in [1,2,3]"
             class="w-full py-4 border-b flex gap-3 justify-start items-center border-gray-200 mx-2">
          <Skeleton shape="circle" size="3rem" />
          <div class="flex flex-grow">
            <div class="flex flex-col gap-2 items-start justify-start">
              <Skeleton borderRadius="12px" width="8rem" height="0.75rem" />
              <Skeleton borderRadius="12px" width="8rem" height="0.5rem" />
            </div>
            <RadioButton inputId="cheese" value="Cheese" class="mr-auto" />
          </div>
        </div>
      </div>
      <div v-else class="flex flex-col overflow-y-auto mx-4 me-6">
        <TransitionGroup appear name="list" tag="div" class="flex flex-col w-full">
          <div v-for="(provider, index) in providers"
               :key="provider.userId"
               :style="{ transitionDelay: `${index * 50}ms` }"
               @click="selectedProviderId = provider.userId"
               :class="['w-full py-4 flex gap-3 justify-start items-center border-gray-200 cursor-pointer', index !== providers.length - 1 ? 'border-b' : '']">
            <Avatar
              size="large"
              shape="circle"
              :image="provider.profileImage"
              class="rounded-2xl text-white" />
            <div class="flex flex-grow justify-between items-center">
              <div class="flex flex-col gap-1 items-start justify-start">
                <span class="font-medium">{{ provider.fullName }}</span>
                <span class="text-sm">{{ getTodayAvailability(provider.userId) }}</span>
              </div>
              <i :class="['pi', provider.userId !== selectedProviderId ? 'pi-circle': 'pi-circle-fill']" />
            </div>
          </div>
        </TransitionGroup>
      </div>
    </div>
    <div class="w-full px-4 flex-shrink-0 shadow-[0_-8px_16px_-4px_rgba(0,0,0,0.05)]">
      <drawer-footer
        approve-label="בחירת עובד"
        @approve-click="chooseProvider"
        @cancel-click="emit('cancel')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { getStringHour } from '@torim-app/utils';
import { useAdminAvailabilityStore } from '@app/stores';
import { useDrawer } from '@torim-app/shared-components';
import { useBookableProviders } from '@app/composables/bookable-providers';

const props = defineProps<{
  initialProviderId?: string;
}>();

const emit = defineEmits<{
  providerSelected: [providerId: string]
  cancel: []
}>();

const { closeDrawer } = useDrawer();
const availabilityStore = useAdminAvailabilityStore();

const selectedProviderId = ref<string | undefined>(props.initialProviderId);

const { bookableProviders: providers } = useBookableProviders();

const getTodayAvailability = (providerUserId: string) => {
  if (!providerUserId) return '';

  const { end, start } = availabilityStore.getWorkingHoursRange(providerUserId, new Date());
  return start && end ? `יש זמינות היום בין ${getStringHour(end)} - ${getStringHour(start)}` : 'אין זמינות היום';
};

const chooseProvider = () => {
  if (selectedProviderId.value) {
    emit('providerSelected', selectedProviderId.value);
    closeDrawer();
  }
};
</script>
